// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Share from "../common/Share.bs.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as TbAtoms from "../team-planner-core/TbAtoms.bs.js";
import * as TbUtils10 from "./TbUtils10.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Clear from "@mui/icons-material/Clear";
import CameraAlt from "@mui/icons-material/CameraAlt";
import UnfoldLess from "@mui/icons-material/UnfoldLess";
import UnfoldMore from "@mui/icons-material/UnfoldMore";
import FormControlLabel from "@mui/material/FormControlLabel";

function TbConfig10(Props) {
  var locale = Props.locale;
  var extended = Props.extended;
  var setExpanded = Props.setExpanded;
  var units = Props.units;
  var setUnits = Props.setUnits;
  var useSkins = Props.useSkins;
  var setUseSkins = Props.setUseSkins;
  var showNames = Props.showNames;
  var setShowNames = Props.setShowNames;
  var onGoToSet6 = Props.onGoToSet6;
  var augments = Props.augments;
  var onScreenshot = Props.onScreenshot;
  var t = Translation.useT(/* Common */0);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var setDisableTooltips = match[1];
  var match$1 = Jotai.useAtom(TbAtoms.compactMode);
  var setCompactMode = match$1[1];
  return React.createElement("div", {
              className: "flex flex-col justify-between h-full"
            }, React.createElement(ContentSection.make, {
                  className: "w-full md:w-auto",
                  children: null
                }, React.createElement("div", {
                      className: "text-sm pb-4 block md:hidden"
                    }, "Tap a unit on board to mark it as 3-star."), React.createElement("div", {
                      className: "text-sm pb-4 hidden md:block xl:hidden"
                    }, t("Right click a unit on board to mark is as 3-star.")), React.createElement("div", {
                      className: "flex flex-col sm:flex-row items-center "
                    }, React.createElement("div", {
                          className: "flex sm:flex-col pr-8"
                        }, React.createElement("div", undefined, React.createElement(Button, {
                                  onClick: (function (param) {
                                      return Curry._1(onGoToSet6, undefined);
                                    }),
                                  variant: "text",
                                  color: "primary",
                                  size: "small",
                                  children: t("Set") + " 14"
                                })), React.createElement("div", {
                              className: "pl-4 sm:pl-0 sm:pt-2"
                            }, React.createElement(Button, {
                                  onClick: (function (param) {
                                      
                                    }),
                                  variant: "contained",
                                  color: "secondary",
                                  size: "small",
                                  children: t("Set") + " 10"
                                }))), React.createElement("div", {
                          className: "text-sm hidden xl:block max-w-[200px] xl:pr-8"
                        }, t("Right click a unit on board to mark it as 3-star.")), React.createElement("div", {
                          className: "pt-3 sm:pt-0 flex flex-row items-center sm:flex-row"
                        }, React.createElement("div", undefined, React.createElement(Share.Button.make, {
                                  forceFull: true,
                                  url: "https://tactics.tools/" + (
                                    locale === "en" ? "" : locale + "/"
                                  ) + "team-builder/" + TbUtils10.encodeQs(units, augments)
                                })), React.createElement("div", {
                              className: "flex flex-col items-stretch w-[210px] px-8"
                            }, React.createElement("div", undefined, React.createElement(Button, {
                                      classes: {
                                        root: "w-full"
                                      },
                                      startIcon: React.createElement(Clear, {}),
                                      onClick: (function (param) {
                                          return Curry._1(setUnits, (function (param) {
                                                        
                                                      }));
                                        }),
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      children: t("Clear Board")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(Button, {
                                      classes: {
                                        root: "w-full"
                                      },
                                      startIcon: extended ? React.createElement(UnfoldLess, {}) : React.createElement(UnfoldMore, {}),
                                      onClick: (function (param) {
                                          return Curry._1(setExpanded, (function (x) {
                                                        return !x;
                                                      }));
                                        }),
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      children: extended ? t("Player Board") : t("Full Board")
                                    })))), React.createElement("div", {
                          className: "pt-3 sm:pt-0 sm:pl-6 flex flex-row"
                        }, React.createElement("div", undefined, React.createElement("div", undefined, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: useSkins,
                                            onChange: (function (e) {
                                                return Curry._1(setUseSkins, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Use Skins")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: showNames,
                                            onChange: (function (e) {
                                                return Curry._1(setShowNames, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Show Names")
                                    }))), React.createElement("div", {
                              className: "pl-3"
                            }, React.createElement("div", undefined, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: !match[0],
                                            onChange: (function (e) {
                                                var v = e.target.checked;
                                                return Curry._1(setDisableTooltips, !v);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Mouse Hover Info")
                                    })), React.createElement("div", {
                                  className: "pt-2"
                                }, React.createElement(FormControlLabel, {
                                      control: React.createElement(Switch, {
                                            checked: match$1[0],
                                            onChange: (function (e) {
                                                return Curry._1(setCompactMode, e.target.checked);
                                              }),
                                            size: "small"
                                          }),
                                      label: t("Positioning Mode")
                                    })))), React.createElement("div", {
                          className: "pl-2"
                        }, React.createElement(IconButton, {
                              color: "primary",
                              onClick: (function (param) {
                                  return Curry._1(onScreenshot, undefined);
                                }),
                              children: React.createElement(CameraAlt, {
                                    fontSize: "small"
                                  })
                            })))));
}

var make = React.memo(TbConfig10);

export {
  make ,
  
}
/* make Not a pure module */
